import { render, staticRenderFns } from "./dept.vue?vue&type=template&id=5e027446"
import script from "./dept.vue?vue&type=script&lang=js"
export * from "./dept.vue?vue&type=script&lang=js"
import style0 from "./dept.vue?vue&type=style&index=0&id=5e027446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports